<template>
  <div class="logcarddd">
    <div class="log-content d-flex">
      <div class="c-icon">
        <img class="check-icon" src="../../../../../assets/Img/icons/check_circle.svg" />
      </div>
      <p class="log">
        Return request #RET8965 has been acknowledged by Ms- Surgical Store
      </p>
      <p class="log-name">Prashanth Kothandaraman</p>
    </div>
    <p class="date">14 Dec, 2022 | 05:03 PM</p>
  </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>

<style lang="scss">
// .log {
//     height: 10px;
// }

.log-content {
  text-align: start;
  align-items: center;

  .c-icon {
    margin-right: 10px;

    .check-icon {
      width: 20px;
      filter: invert(74%) sepia(3%) saturate(12%) hue-rotate(326deg) brightness(85%) contrast(75%);
    }
  }

  .log {
    font-size: 14px;
    font-weight: 400;
  }

  .log-name {
    font-size: 14px;
    font-weight: 400;
    color: #3096ff;
    padding-left: 10px;
    cursor: pointer;
  }
}

.date {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}

.logcarddd {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #e1e1e1;
  background-color: #ffffff;
  border-radius: 3px;
  border-collapse: collapse;
  width: 100%;
  margin: 15px 10px;
}
</style>
